import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import { colors } from '@mm/utils';

type Props = {
  className?: string;
  color?: string;
  size?: number;
  style?: CSSProperties;
};

export const Circle = ({
  className,
  color,
  size = 10,
  style: propsStyle,
}: Props) => {
  const style = {
    height: size,
    width: size,
    borderRadius: '50%',
    backgroundColor: color || colors.grayLight,
    ...propsStyle,
  };

  return <div className={classNames(className)} style={style} />;
};
